/*
 * @Descripttion:
 * @version:
 * @Author: wanglongx
 * @Date: 2020-06-05 09:35:24
 * @LastEditors: Qiaofan
 * @LastEditTime: 2023-08-12 11:04:39
 */
import React, { useContext } from 'react';
import { Item } from '@platform/template';
import FormContext from '../formContent';
import { Tooltip, GridContainer, Tag, Hexagon } from '@platform/base';
import {
    formatDot,
    addZero,
    commafy,
    getRandomPassword,
    changeTime,
    getLangCode,
    linkTo,
    ajax,
    toast,
    getSysFieldid,
    getParentWindow,
    getTopWindow,
    cardCache,
} from '@platform/api';
import Hyperlink from '../../Hyperlink';
import { getMainId } from '../utils';
const { getHyperlinkValue } = Hyperlink;
const { updateCache } = cardCache;

// IM refer refpath
const IMpath = [
    'uap/refer/riart/userDefaultRefer/index',
    'uapbd/refer/psninfo/PsndocRiartTreeGridRef/index',
    'uap/refer/riart/userAllTableRef/index',
    'uapbd/refer/psninfo/PsndocTreeGridRef/index',
];

const defaultColor = new Set(['#111111', '#555555', '#111', '#555']);
//const needTrimType = new Set(['input', 'textarea', 'residtxt']);
const needTrimType = new Set(['input', 'textarea']);

// tooltips \\n 解析不来，替换成\n
function getTooltipMsg(msg) {
    if (typeof msg === 'string' && msg.indexOf("\\n") > -1) {
        msg = msg.replaceAll("\\n", "\n");
    }
    return msg;
}

/**
 * 改造思路：
 * 1.将通用的数据处理和视图抽出来，基本的label和最底层的Item，核心数据也在这一层处理， 上层通过FormItem组件调用
 */
function Filed(props) {
    let {
        label,
        tooltips,
        tooltipsClassName = '',
        attrcode,
        required,
        itemtype,
        verify,
        errorMsg,
        errormessage,
        languageMeta,
        singleFormCode,
        hyperlinkflag,
        renderStatus,
        refcode,
        color,
        render,
        fastToNext,
        maxlength,
        ishighlight,
        contentcolor,
        fontSize,
        realBrowse,
        datatype,
        hyperlinkname,
        hyperlinkurl,
        hyperlinktype,
        hintmessage = '',
        beforeLabel, // 自定义label左侧内容 ()=>{}
        designlabelcontent, // 下拉选项展示为标签格式
        showClose, // 是否显示清空按钮
        attachmentParams, // 设计器配置的附件参数
        _runContext,
        limitItemHeight,
    } = props;
    const { areaId, form, onAfterEvent, onBeforeValueChange, onBeforeEvent, config = {}, getHotKeyConfig = () => { }, inputChange } = useContext(FormContext);
    const { getItemValue, setItemValue, getStatus, getInnerHooks, getAllFormValue, setOldValue, setItemAttribute, getEventListener } = form;
    const { getJson, getReplaceItem, getStore } = getInnerHooks();
    const status = getStatus();
    if (status === 'browse' || required !== true) {
        setItemAttribute(attrcode, 'verify', true, false);
    }
    const json = getJson();
    let onlyShowBorder = config.onlyShowBorder; //展示正常的边框模式
    let underlineBorder = config.underlineBorder;

    //xiqq测试添加属性
    let titleFontWeight = !!getStore('titleFontWeight'),
        contentFontWeight = !!getStore('contentFontWeight'),
        titleColor = getStore('titleColor'),
        onlyBorderBottom = !onlyShowBorder && (underlineBorder ?? getStore('onlyBorderBottom'));
    const titleFontWeightStyle = titleFontWeight ? { fontWeight: 600 } : {};
    const contentFontWeightStyle = contentFontWeight ? { fontWeight: 600 } : {};
    const titleColorStyle = titleColor !== 'null' && titleColor ? { color: titleColor } : {};
    let { pageScope = {}, meta = {} } = getHotKeyConfig() || {};
    let colon = '';
    if (
        (label && realBrowse) ||
        (itemtype === 'attachment' && status === 'browse')
    ) {
        colon = ':';
    }
    if (verify === false) {
        if (realBrowse) {
            errorMsg = null;
        } else {
            errorMsg = (
                <span
                    style={{
                        color: 'red',
                        fontSize: '10px',
                    }}
                    className="input-error-message"
                >
                    {errormessage || json['page-form-0008']}
                </span>
            );
        }
    }
    // 替换组件
    props.renderItem = function ({ isEdit }) {
        if (isEdit) {
            let customRender;
            // 表格用
            if (renderStatus === 'edit' && typeof render === 'function') {
                customRender = render(
                    getItemValue(attrcode),
                    getAllFormValue(),
                    status,
                );
            } else {
                customRender = getReplaceItem(attrcode);
            }
            if (customRender) {
                return customRender;
            }
        }
    };
    // 自定义render标识
    let customRender = null;
    if (renderStatus === 'edit' && typeof render === 'function') {
        customRender = render(
            getItemValue(attrcode),
            getAllFormValue(),
            status,
        );
    } else {
        customRender = getReplaceItem(attrcode);
    }
    props.customRender = customRender ? true : false;
    // switch_browse 特殊处理
    if (itemtype === 'switch_browse') {
        let config = getStore(['FormInstance', 'props', 'config']);
        props.cancelPSwitch = config.cancelPSwitch;
        props.disabled = config.editSwitch
            ? props.disabled
            : status === 'browse'
                ? props.disabled
                : true;
    }

    if (itemtype === 'attachment') {
        props.disableModify = status === 'browse' ? props.disabled : true;
        let fieldValue = {};
        if (attachmentParams) {
            let params = JSON.parse(attachmentParams) || [];
            params.forEach(item => {
                let { areacode, parmasCode: paramsCode, parmasType: paramsType, value } = item;
                if (paramsType === 'field') {
                    // 如果是字段类型，取字段的值
                    let mainId = getMainId(areacode, meta);
                    let formValue = pageScope?.form?.getFormItemsValue(
                        mainId,
                        value,
                    );
                    fieldValue[paramsCode] = formValue?.value || '';
                } else if (paramsType === 'const') {
                    // 如果是常量，直接赋值
                    fieldValue[paramsCode] = value;
                }
            });
        }
        props.customize = { ...props.customize, ...fieldValue };
        let formData = getAllFormValue();
        props.rowInfo = { values: formData };
        props.colInfo = { ...props };
    }
    let content = '';
    if (errorMsg) {
        content = <div className="form-item-errormsg">{errorMsg}</div>;
    }
    // refer IM
    let IMreferFlag = false;
    if (
        itemtype === 'refer' &&
        (getItemValue(attrcode) || {}).value &&
        getTopWindow().ImTool
    ) {
        if (IMpath.includes(refcode)) {
            IMreferFlag = true;
        }
    }
    // 精度处理
    let scale;
    if (itemtype === 'number') {
        scale = (getItemValue(attrcode) || {}).scale;
        if (
            scale === undefined ||
            scale === null ||
            scale == '-1' ||
            scale == -1
        ) {
            scale = props.scale;
        }
        if (
            scale === undefined ||
            scale === null ||
            scale == '-1' ||
            scale == -1
        ) {
            scale = 0;
        }
        props.scale = Number(scale);
    }
    let tabIndex = props.tabskip ? { tabIndex: -1 } : {};

    let contentStyle = contentcolor ? { color: contentcolor } : {};

    let needTrim = needTrimType.has(props.itemtype);
    // 设置 popupcontainer
    let getPopupContainerObj = {};
    if (typeof config.getPopupContainer === 'function') {
        // 下拉组件使用
        getPopupContainerObj.getPopupContainer = config.getPopupContainer;
        // 参照历史使用
        getPopupContainerObj.dropDownContainer = config.getPopupContainer;
    }
    let { rows } = props;
    let newRows = Number(props.rows);
    if(newRows === 0){
        let defineRows = typeof props.define2 === 'string' && props.define2.includes('rows:') ? props.define2.match(/rows:\s*(\d+)/)[1] : undefined;
        newRows = defineRows;
    }
    let itemDom = (
        <Item
            {...props}
            style={contentStyle}
            rows={newRows}
            showClose={
                typeof showClose === 'boolean'
                    ? showClose
                    : itemtype === 'input'
                        ? true
                        : false
            }
            trim={needTrim}
            {...tabIndex}
            placeholder={hintmessage}
            browse={realBrowse}
            maxlength={maxlength}
            refRelyCondition={() => {
                return getCondition(form, props, pageScope, meta);
            }}
            isCheckChinese={!!maxlength}
            // key={attrcode}
            setFieldValue={({ value, attrcode, componentValue, onBeforeValueChange }) => {
                let filedValue;
                // 处理参照值
                if (props.itemtype === 'refer') {
                    filedValue = { ...value, ...componentValue };
                } else {
                    filedValue = value;
                    // NCC-216861 checkbox_switch switch 类型返回数据增加display字段
                    if (
                        itemtype === 'checkbox_switch' ||
                        itemtype === 'switch'
                    ) {
                        filedValue = {
                            ...value,
                            display: value.value
                                ? json['page-form-0007']
                                : json['page-form-0004'],
                        };
                    }
                }
                // 供应链换算率 建议移除 不应该加载组件内部
                if (
                    itemtype === 'input' &&
                    ['vchangerate', 'vqtunitrate'].includes(attrcode)
                ) {
                    let reg = /^[0-9\/\.]+$/;
                    if (filedValue?.value && !reg.test(filedValue.value)) {
                        //只能输入数字和/
                        return;
                    }
                }

                //胡杰李忠博加
                if (typeof inputChange === 'function' && !inputChange(props, value)) {
                    return;
                }

                // 如果 注册了 onBeforeValueChange 回调，在基础组件值改变调用 setItemValue 的时候，不走维度查询
                setItemValue(attrcode, filedValue, { inner: true, pageScope, requestMetaByDimensionFlag: !!onBeforeValueChange });
            }}
            getFieldValue={({ attrcode }) => {
                let currentValue = getItemValue(attrcode);

                // if (['checkbox_switch', 'switch', 'switch_browse'].includes(itemtype) && realBrowse) {
                //     currentValue.display = currentValue.value ? json["page-form-0007"] : json["page-form-0004"];
                // }
                if (realBrowse) {
                    switch (itemtype) {
                        case 'checkbox_switch':
                        case 'switch_browse':
                            currentValue.display = currentValue.value
                                ? json['page-form-0007']
                                : json['page-form-0004'];
                            break;
                        case 'switch':
                            currentValue.display = currentValue.value
                                ? json['page-form-0014']
                                : json['page-form-0013'];
                            break;
                        default:
                            break;
                    }
                }
                return currentValue;
            }}
            onBeforeEvent={async ({ value, event }) => {
                // 快捷键相关 TODO 编辑前一些快捷键的特殊情况处理
                // let { getHotKeyConfig = () => { } } = config;
                // let { meta, orderOfHotKey, onLastFormEnter } = getHotKeyConfig() || {};
                // let { getStore, getAllFormItem, getSingleForm } = form.getInnerHooks();
                // console.log(form);
                // // 處理states 數據 TODO 後面可以考慮優化下
                // let items = getAllFormItem() || {};
                // let states = {
                //     disabled: {},
                //     visible: {},
                //     form: {},
                // };
                // for (let key in items) {
                //     let item = items[key];
                //     states.disabled[item.attrcode] = !!item.disabled;
                //     states.visible[item.attrcode] = !!item.visible;
                //     states.form[item.attrcode] = item;
                // }
                // let formList = getStore('formList');
                // let itemKeys = [];
                // formList.map(id => itemKeys = itemKeys.concat([], getSingleForm(id) || []));
                // let result = findFocusItem(itemKeys, states.disabled, props);
                // console.log(formList, itemKeys, states.disabled, props, result);
                // if (that.keyDownTab) {
                //     handlerEnter();
                //     that.keyDownTab = false;
                // } else if (that.keyDownTabShift) {
                //     PubSub.publish('autoFocus', { data: result.next });
                //     that.keyDownTabShift = false;
                // } else {
                //     target.fromProgram
                //         ? handlerEnter()
                //         : target.blur();
                //     delete target.fromProgram;
                // }

                if (typeof onBeforeEvent == 'function') {
                    return (
                        (await onBeforeEvent(
                            areaId,
                            attrcode,
                            value,
                            getAllFormValue(),
                            props,
                            event,
                        )) !== false
                    );
                } else {
                    return true;
                }
            }}
            onBeforeValueChange={typeof onBeforeValueChange == 'function' ? async ({ value, oldValue, componentValue, event }) => {
                return await onBeforeValueChange({
                    areaId,
                    attrcode,
                    curMetaItem: props,
                    value:
                        props.itemtype == 'refer'
                            ? { ...value, ...componentValue }
                            : value,
                    oldValue,
                    componentValue,
                    allValue: getAllFormValue(),
                    singleFormCode,
                    event,
                }) !== false;
            } : undefined}
            onAfterEvent={({ value, oldValue, componentValue, event }) => {
                if (itemtype === 'residtxt') {
                    // 主语言没值时，取登录语言的值
                    if (!value[attrcode]?.value) {
                        let loginCode = getLangCode(),
                            loginIndex =
                                languageMeta.find(
                                    e => e.languageCode === loginCode,
                                )?.index || '',
                            loginValue = componentValue[attrcode + loginIndex];
                        setItemValue(attrcode, loginValue, { inner: true });
                        loginValue?.value &&
                            setItemAttribute(attrcode, 'verify', true);
                    }
                } else if (
                    itemtype === 'input' &&
                    ['vchangerate', 'vqtunitrate'].includes(attrcode)
                ) {
                    let reg =
                        /^([1-9][0-9]*|0)(\.\d{1,})?(\/)(([1-9][0-9]*)(\.\d{1,})?|(\d\.\d{1,}))$/;
                    if (value?.value && !reg.test(value.value)) {
                        //只能输入数字和/或.
                        value = { value: '' };
                        let titleTip = json['page-form-0009'];
                        let contentTip = json['page-form-0011'];
                        toast({
                            mark: 'form_onBlur',
                            color: 'danger',
                            title: titleTip,
                            content: ` ${contentTip}"1/2"`,
                        });
                        setItemValue(attrcode, value, { inner: true });
                        value?.value &&
                            setItemAttribute(attrcode, 'verify', true);
                        return;
                    }
                }
                setOldValue(attrcode, oldValue);
                if (typeof onAfterEvent == 'function') {
                    onAfterEvent({
                        areaId,
                        attrcode,
                        curMetaItem: props,
                        value:
                            props.itemtype == 'refer'
                                ? { ...value, ...componentValue }
                                : value,
                        oldValue,
                        componentValue,
                        allValue: getAllFormValue(),
                        singleFormCode,
                        event,
                    });
                    let eventListenerObj = getEventListener();
                    for (const key in eventListenerObj) {
                        if (Object.hasOwnProperty.call(eventListenerObj, key)) {
                            const callback = eventListenerObj[key];
                            if (
                                key === 'onAfterEvent' &&
                                Array.isArray(callback)
                            ) {
                                callback.forEach(fun => {
                                    typeof fun === 'function' && fun();
                                });
                            }
                        }
                    }
                }
                if (itemtype === 'residtxt') {
                    value?.[attrcode]?.value &&
                        setItemAttribute(attrcode, 'verify', true);
                } else {
                    value?.value && setItemAttribute(attrcode, 'verify', true);
                }
                // 附件同步数据到列表缓存
                if (itemtype === 'attachment') {
                    // createForm 传入 dataSource pkname 和创建 simpleTable 传入的 dataSource pkname 保持一致，才能保证缓存数据同步
                    // 附件编辑后通过 updateCache 更新列表缓存
                    let { pkname, dataSource } = config;
                    let updateValues = getAllFormValue();
                    let pkvalue = updateValues[pkname]?.value;
                    if (pkname && dataSource && pkvalue) {
                        updateCache(pkname, pkvalue, null, areaId, dataSource, updateValues, _runContext);
                    }
                }
            }}
            onEnter={({ e }) => {
                if (config.onCustomEnter) {
                    return;
                }
                // 防止重复
                if (window.triggerOnEnter) {
                    return;
                }
                console.log('formitem enter trigger@baseComponent');
                // 只触发一次
                window.triggerOnEnter = true;
                setTimeout(() => {
                    let result = fastToNext(attrcode, itemtype);
                    window.triggerOnEnter = false;
                }, 20);
            }}
            path={[attrcode]}
            {...getPopupContainerObj}

        // whichKeyToDisplay={(getItemValue(attrcode) || {}).display ? 'display' : 'value'}
        />
    );
    if (realBrowse && typeof render === 'function') {
        itemDom = render(getItemValue(attrcode), getAllFormValue(), status);
    }
    // 标签 浏览态显示标签
    if (
        realBrowse &&
        (itemtype === 'select' || itemtype === 'refer') &&
        designlabelcontent
    ) {
        let currentValue = getItemValue(attrcode);
        try {
            let option = JSON.parse(designlabelcontent);
            // NCC-340984 designlabelcontent 中的 item.key 是个string，  需要转一下 value
            let renderItem = option.find(
                item => item.key === String(currentValue.value),
            );
            if (renderItem) {
                let { value, borderRadius, color, icon } = renderItem;
                itemDom = (
                    <Hexagon
                        text={currentValue.display || value}
                        backgroundColor={color}
                        borderRadius={borderRadius}
                        icon={icon}
                    />
                );
            } else {
                itemDom = currentValue.display;
            }
        } catch (error) {
            itemDom = currentValue.display;
        }
    }

    color = defaultColor.has(color) ? '' : color;
    let labelStyle = color ? { color } : {};
    

    let $element = itemDom;
    let elementValue = (getItemValue(attrcode) || {}).value;

    const tipContent = getHyperlinkValue({
        datatype: datatype,
        hyperlinkflag: hyperlinkflag,
        hyperlinktype: hyperlinktype,
        hyperlinkname: hyperlinkname,
        hyperlinkurl: hyperlinkurl,
        value: elementValue,
        browse: realBrowse,
    });
    let formItemClassName = realBrowse
        ? 'form-item-pre'
        : 'form-item-pre-browse';
    $element = hyperlinkflag ? (
        <Hyperlink
            datatype={datatype}
            hyperlinkflag={hyperlinkflag}
            hyperlinktype={hyperlinktype}
            hyperlinkname={hyperlinkname}
            hyperlinkurl={hyperlinkurl}
            value={elementValue}
            browse={realBrowse}
            pageId={getStore(['pageid'])}
            areaCode={singleFormCode}
            attrCode={attrcode}
            dataId={(getItemValue(attrcode) || {}).value}
            className={'form-hyperlink'}
            color={contentcolor}
        >
            {' '}
            <span className="form-item-pre" style={{ color: contentcolor }}>
                {itemDom}
            </span>{' '}
        </Hyperlink>
    ) : (
        <span className={formItemClassName}>{itemDom}</span>
    );
    let labelContentTitle = tooltips ? { title: label } : {};
    return (
        <React.Fragment>
            <div className={`form-item-label ${ishighlight && fontSize ? 'font-size-' + fontSize : ''}`} style={{ ...titleFontWeightStyle, ...titleColorStyle, ...labelStyle }} title={tooltips ? '' : label}>
                {(!realBrowse && required) && <span className="base-mast iconfont icon-xinghao"></span>}
                {typeof beforeLabel === 'function' && beforeLabel(attrcode)}
                <span className="form-item-label-text" {...labelContentTitle}>
                    {label}
                </span>
                {tooltips ? (
                    <Tooltip
                        placement="top"
                        className={tooltipsClassName}
                        overlay={getTooltipMsg(tooltips)}
                    >
                        <span className="form-item-msg">
                            <i className="iconfont icon-shuoming1 icon-msg-unhover" />
                            <i className="iconfont icon-shuoming2 icon-msg-hover " />
                        </span>
                    </Tooltip>
                ) : null}
                <span className="form-item-colon">{colon}</span>
            </div>
            <TooltipsRefer
                content={content}
                verify={verify}
                realBrowse={realBrowse}
                itemtype={itemtype}
                limitItemHeight={limitItemHeight}
            >
                <div
                    className={`form-component-item-wrapper ${itemtype}-wrapper ${status} ${ishighlight && fontSize ? 'font-size-' + fontSize : ''} ${onlyBorderBottom ? 'only-border-bottom-style' : ''}`}
                    style={{ ...contentStyle, ...contentFontWeightStyle }}
                    onKeyDown={e => {
                        // console.log('cell onKeyDow trigger', e);
                        if (e.key === 'Enter' && e.keyCode !== 229) {
                            if (config.onCustomEnter) {
                                config.onCustomEnter(
                                    areaId,
                                    attrcode,
                                    itemtype,
                                );
                                return;
                            }
                            // 防止重复
                            if (window.triggerOnEnter) {
                                return;
                            }
                            window.triggerOnEnter = true;
                            e.stopPropagation();
                            console.log('formitem enter trigger@itemSpan');
                            setTimeout(() => {
                                let result = fastToNext(attrcode, itemtype);
                                window.triggerOnEnter = false;
                            }, 20);
                        }
                        if (typeof config.onCellKeyDown === 'function') {
                            config.onCellKeyDown(attrcode, e);
                        }
                    }}
                >
                    {realBrowse ? $element : itemDom}
                    {realBrowse ? (
                        IMreferFlag ? (
                            <i
                                className="iconfont icon-renyuan imrefer"
                                onClick={() =>
                                    handleIMrefer(
                                        (getItemValue(attrcode) || {}).value,
                                        json,
                                    )
                                }
                            />
                        ) : null
                    ) : null}
                </div>
            </TooltipsRefer>
        </React.Fragment>
    );
}

function getCondition(form, props, pageScope, meta) {
    let { itemtype, refcondition } = props;
    let relyConditon = [];
    if (refcondition) {
        let condition = JSON.parse(refcondition);
        if (itemtype === 'refer' && Array.isArray(condition)) {
            condition.forEach(e => {
                if (e && e.key && e.value && e.areacode) {
                    // 有可能这里配的是表单分组id，需要根据 formrelation 找到主表id
                    let mainFormId = e.areacode;
                    if (meta?.formrelation) {
                        for (const key in meta.formrelation) {
                            if (
                                Object.hasOwnProperty.call(
                                    meta.formrelation,
                                    key,
                                )
                            ) {
                                const element = meta.formrelation[key];
                                element?.includes(e.areacode) &&
                                    meta[key]?.moduletype === 'form' &&
                                    (mainFormId = key);
                            }
                        }
                    }
                    // 还有一种情况，配置的是多页签表单 tabs其他tab，需要根据 formassociatedrelation 找到主表id
                    if (meta?.formassociatedrelation) {
                        for (const key in meta.formassociatedrelation) {
                            if (
                                Object.hasOwnProperty.call(
                                    meta.formassociatedrelation,
                                    key,
                                )
                            ) {
                                const element =
                                    meta.formassociatedrelation[key]['formtabs'];
                                element?.includes(mainFormId) &&
                                    meta[key]?.moduletype === 'form' &&
                                    (mainFormId = key);
                            }
                        }
                    }
                    let eValue = pageScope?.form?.getFormItemsValue(
                        mainFormId,
                        e.value,
                    );
                    if (eValue && eValue.value) {
                        e.value = eValue.value;
                        relyConditon.push(e);
                    }
                } else if (e && e.valueType && e.valueType === 'const') {
                    relyConditon.push(e);
                }
            });
        }
    }
    return relyConditon;
}
// 超链接处理
function handleClick(
    hyperlinkflag,
    name,
    pagestatus,
    pageId,
    areaCode,
    dataId,
) {
    if (hyperlinkflag && pagestatus === 'browse' && dataId) {
        linkTo(pageId, areaCode, name, dataId);
    }
}

// im处理
function handleIMrefer(dataId, json) {
    ajax({
        url: '/nccloud/platform/login/openim.do',
        data: { userid: dataId },
        success: res => {
            if (res && res.data) {
                // IM window
                getTopWindow().ImTool &&
                    getTopWindow().ImTool.dispatch('switchChatTo', {
                        yht_id: res.data,
                        type: 'chat',
                    });
                // IM 存在 不再点击
                if (
                    getTopWindow().document.getElementById('ykj-frame') &&
                    getTopWindow().document.getElementById('ykj-frame').style
                        .display == 'none'
                ) {
                    let imBtnForNcc =
                        getTopWindow().document.getElementById('imBtnForNcc');
                    imBtnForNcc && imBtnForNcc.click();
                }
            } else {
                if (res.success && !res.data) {
                    toast({
                        mark: 'userim-wraning',
                        color: 'danger',
                        title: json['page-form-0009'],
                        content: json['page-form-0012'],
                    });
                }
            }
        },
        error: () => {
            console.log('IM');
        },
    });
}

class TooltipsRefer extends React.Component {
    state = { isHover: false };

    onMouseLeave = e => {
        e.stopPropagation();
        this.setState({ isHover: false });
    };
    onMouseEnter = e => {
        let { itemtype } = this.props;
        e.stopPropagation();
        if (itemtype === 'refer') {
            if (e.target.className.includes('refer-pop-window-show')) {
                return;
            }
            if (!e?.relatedTarget?.className?.includes('group-form-item')){
                return;
            }
        }
        this.setState({ isHover: true });
    };
    onClick = (itemtype, e) => {
        if (itemtype === 'refer') {
            if (e.target.className.includes('icon-refer')) {
                this.setState({ isHover: false });
            }
        }
        if (
            itemtype === 'input' &&
            e?.target?.className?.includes('icon-choose-image')
        ) {
            this.setState({ isHover: false });
        }
    };

    render() {
        let { children, content, verify, realBrowse, itemtype, limitItemHeight } = this.props;
        return (
            <Tooltip
                placement="top"
                overlay={content}
                id="top"
                visible={content && this.state.isHover}
                overlayClassName={`${verify === false && !realBrowse ? 'form-item-show-tip' : 'form-item-hide-tip'}`}
            >
                <div
                    className={`form-item-control ${verify === false ? 'verify-error' : ''} ${limitItemHeight ? 'form-item-limit-height' : ''}`}
                    onClick={this.onClick.bind(this, itemtype)}
                    onMouseLeave={this.onMouseLeave}
                    onMouseEnter={this.onMouseEnter}
                >
                    {children}
                </div>
            </Tooltip>
        );
    }
}

export default Filed;
